import React from 'react';
import Icon from '../../../components/AppIcon';

const PredictionImpactPanel = ({ impactData }) => {
  if (!impactData) {
    return (
      <div className="bg-card rounded-lg border border-border p-6 text-center">
        <Icon name="Info" size={48} className="mx-auto mb-4 text-muted-foreground" />
        <p className="text-muted-foreground">
          Select a match and enter results to preview prediction impact
        </p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="TrendingUp" size={20} />
          Prediction Impact Preview
        </h3>
        <p className="text-sm text-muted-foreground mt-1">
          Points calculation for {impactData?.affectedUsers} users
        </p>
      </div>
      <div className="p-4 md:p-6 space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-muted rounded-lg p-4">
            <p className="text-sm text-muted-foreground mb-1">Total Predictions</p>
            <p className="text-2xl font-bold text-foreground">{impactData?.totalPredictions}</p>
          </div>
          <div className="bg-muted rounded-lg p-4">
            <p className="text-sm text-muted-foreground mb-1">Correct Predictions</p>
            <p className="text-2xl font-bold text-success">{impactData?.correctPredictions}</p>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-medium text-foreground mb-3">Points Distribution</h4>
          <div className="space-y-3">
            {impactData?.pointsBreakdown?.map((item, index) => (
              <div key={index} className="flex items-center justify-between p-3 bg-muted rounded-lg">
                <div className="flex items-center gap-3">
                  <Icon name={item?.icon} size={18} className="text-primary" />
                  <span className="text-sm text-foreground">{item?.category}</span>
                </div>
                <div className="text-right">
                  <p className="text-sm font-medium text-foreground">
                    {item?.usersAwarded} users
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {item?.totalPoints} points
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-primary/10 border border-primary/20 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Icon name="AlertCircle" size={20} className="text-primary flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-foreground mb-1">
                Leaderboard Changes
              </p>
              <p className="text-xs text-muted-foreground">
                {impactData?.leaderboardChanges} users will see position changes after this result is published
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PredictionImpactPanel;